import React from "react";
import { BsCart2 } from "react-icons/bs";
import { HiOutlineCollection } from "react-icons/hi";
import { CgProfile } from "react-icons/cg";
import { BiMessageEdit } from "react-icons/bi";
// import  {Bargraph}  from './Bargraph';
import Bargraph from "./bargraph";

import "../styles/content.scss";
import Linechart from "./linechart";
import Circlechart from "./circlechart";
import Tables from './table';

import styled from "styled-components";

function Content() {
  const StyledIcon = styled(BsCart2)`
    background-color: #7060ff;
    color: #f9ffff;
  `;

  const TotalProducts = styled(HiOutlineCollection)`
    background-color: #f06f2d;
    color: #f9ffff;
  `;

  const StoreVisitors = styled(CgProfile)`
    background-color: #fbc01c;
    color: #f9ffff;
  `;

  const Revenue = styled(BiMessageEdit)`
    background-color: #1eca52;
    color: #f9ffff;
  `;

  return (
    <div>
      <div className="row ">
        <div className="col-sm-12 col-md-6 ">
          <div className="row g-3">
            <div className="col-md-6 col-sm-12 ">
              <div className="card p-2" style={{ background: "#191C23" }}>
                <div className="orders d-flex pt-3 pb-3">
                  <div className="icon">
                    <StyledIcon
                      style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                  <div className="contentupper" style={{ color: "#7C7F88" }}>
                    Total Products
                  </div>
                </div>
                <div className="content d-flex justify-content-between pt-3 pb-3">
                  <span style={{ color: "#FAFEFF" }}>45,9215</span>
                  <span style={{ color: "#1ECA52" }}>0.02%</span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 ">
              <div className="card p-2" style={{ background: "#191C23" }}>
                <div className="orders d-flex pt-3 pb-3">
                  <div className="icon">
                    <TotalProducts
                      style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                  <div className="contentupper" style={{ color: "#7C7F88" }}>
                    Total Products
                  </div>
                </div>
                <div className="content d-flex justify-content-between pt-3 pb-3">
                  <span style={{ color: "#FAFEFF" }}>33,9215</span>
                  <span style={{ color: "#1ECA52" }}>0.02%</span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 ">
              <div className="card p-2" style={{ background: "#191C23" }}>
                <div className="orders d-flex pt-3 pb-3">
                  <div className="icon">
                    <StoreVisitors
                      style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                  <div className="contentupper" style={{ color: "#7C7F88" }}>
                    Store visitors
                  </div>
                </div>
                <div className="content d-flex justify-content-between pt-3 pb-3">
                  <span style={{ color: "#FAFEFF" }}>1,35,9215</span>
                  <span style={{ color: "#1ECA52" }}>0.02%</span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 ">
              <div className="card p-2" style={{ background: "#191C23" }}>
                <div className="orders d-flex pt-3 pb-3">
                  <div className="icon">
                    <Revenue
                      style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                  <div className="contentupper" style={{ color: "#7C7F88" }}>
                    Revenue
                  </div>
                </div>
                <div className="content d-flex justify-content-between pt-3 pb-3">
                  <span style={{ color: "#FAFEFF" }}>$ 24,45,9215</span>
                  <span style={{ color: "#1ECA52" }}>0.02%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-6">
         
            <Bargraph />
         
        </div>
      </div>
        <div className="row mt-3">
          <div className="col-sm-12 col-md-7">
            <Linechart />
          </div>
          <div className="col-sm-12 col-md-5">
            <Circlechart />
          </div>
        </div>
        <div className="card mt-3 mb-3" style={{ background: "#191C23" }}>
             <div className="table-header d-flex justify-content-between px-2 pr-2 mt-3 mb-4">
               <h3 className="header-first-content" style={{ color: "#DEE1E8" }}>Recent Order</h3>
               <h3 className="header-second-content" style={{ color: "#DEE1E8" }}>Icon</h3>
            </div>
       
           <Tables/>
        </div>
     
    </div>
  );
}

export default Content;
